import axios from 'axios';

const BACKEND_API_URL = window.AMS_CONFIG?.API_URL || 'http://localhost:8000';
const API_PATH = window.AMS_CONFIG?.API_PATH || '/api';
const API_BASE_URL = `${BACKEND_API_URL}${API_PATH}`;

export const atlApi = {
  async importCompetitors(file) {
    const accessToken = localStorage.getItem('accessToken');
    const formData = new FormData();
    formData.append('file', file);

    const res = await axios.post(`${API_BASE_URL}/atl/import-competitors/`, formData, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.data;
  },
  async getTable(year, advertiser, batchId, region = 'NAT') {
    const accessToken = localStorage.getItem('accessToken');
    const params = {};
    if (batchId && String(batchId).trim() !== '') {
      params.batch_id = batchId;
    } else if (year) {
      params.year = year;
    }
    if (advertiser && String(advertiser).trim() !== '') {
      params.advertiser = advertiser;
    }
    if (region && String(region).trim() !== '') {
      params.region = region;
    }
    const res = await axios.get(`${API_BASE_URL}/atl/table/`, {
      params,
      headers: { 'Authorization': `Bearer ${accessToken}` }
    });
    return res.data;
  },
  async listBatches() {
    const accessToken = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/atl/batches/`, {
      headers: { 'Authorization': `Bearer ${accessToken}` }
    });
    return res.data;
  },
  async runAgent(prompt, chart = 'auto', gemini = false) {
    const accessToken = localStorage.getItem('accessToken');
    const res = await axios.post(`${API_BASE_URL}/atl/agent-run/`, { prompt, chart, gemini }, {
      headers: { 'Authorization': `Bearer ${accessToken}` }
    });
    return res.data;
  },
  async autocompleteBrands(query = '', limit = 20) {
    const accessToken = localStorage.getItem('accessToken');
    const params = { };
    if (query && String(query).trim() !== '') params.query = query.trim();
    if (limit) params.limit = limit;
    const res = await axios.get(`${API_BASE_URL}/atl/brands/`, {
      params,
      headers: { 'Authorization': `Bearer ${accessToken}` }
    });
    return res.data;
  },
  async autocompleteRegions(query = '', limit = 20) {
    const accessToken = localStorage.getItem('accessToken');
    const params = { };
    if (query && String(query).trim() !== '') params.query = query.trim();
    if (limit) params.limit = limit;
    const res = await axios.get(`${API_BASE_URL}/atl/regions/`, {
      params,
      headers: { 'Authorization': `Bearer ${accessToken}` }
    });
    return res.data;
  }
};

export default atlApi;


